import React from "react";
import Badge from "./Badge";

interface PageTitleBoxProps {
  badge?: string;
  badgeColor?: "navy" | "gray" | "blue" | "red" | "orange" | "white";
  title?: React.ReactNode;
  highlightText?: string;
  highlightColor?: string;
  subtitle?: React.ReactNode;
  showSeparator?: boolean;
  className?: string;
}

const badgeColors = {
  navy: "bg-[#032C6D] text-white",
  gray: "bg-gray-600 text-white",
  blue: "bg-[#4361ee] text-white",
  red: "bg-[#e74c3c] text-white",
  orange: "bg-[#d97706] text-white",
  white: "bg-white text-gray-800 border border-gray-300",
};

const PageTitleBox: React.FC<PageTitleBoxProps> = ({
  badge,
  badgeColor = "navy",
  title,
  highlightText,
  highlightColor = "#4361ee",
  subtitle,
  showSeparator = false,
  className = "",
}) => {
  return (
    <div className={`mb-[30px] text-center sm:text-left ${className}`}>
      {badge && (
        <Badge className={`inline-block px-6 mb-4 ${badgeColors[badgeColor]}`}>{badge}</Badge>
      )}

      {title && (
        <h2
          className="w-[900px] mx-auto  mb-[8px] font-bold leading-[1.2]"
          style={{
            fontSize: "var(--font-headline-large, 4rem)",
            color: "#1a1a1a",
          }}
        >
          {title}
          {highlightText && (
            <>
              {" "}
              <span style={{ color: highlightColor }}>{highlightText}</span>
            </>
          )}
        </h2>
      )}

      {showSeparator && <div className="w-[160px] h-[2px] my-6 bg-gray-300 sm:mx-0 mx-auto" />}

      {subtitle && (
        <p
          className="leading-[1.5] font-medium mt-4"
          style={{
            fontSize: "2rem",
            color: "#202020",
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageTitleBox;
